import axiosInstance from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}invoice_file_permissions`;

const getHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  const token = localStorage.getItem("loginUser");
  return {
    Authorization: `Bearer ${accessToken}`,
    XRefreshToken: `${token}`,
    "Content-Type": "application/json",
  };
};

export const invoicePermissionsService = {
  // Get permissions for an invoice or user
  getPermissions: async (invoiceIdOrUserId, fileType = "net", isUserId = false) => {
    try {
      let url = BASE_URL;
      if (isUserId) {
        url = `${BASE_URL}?user_id=${invoiceIdOrUserId}&file_type=${fileType}`;
      } else {
        url = `${BASE_URL}?invoice_id=${invoiceIdOrUserId}&file_type=${fileType}`;
      }
      
      const response = await axiosInstance.get(url, {
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get permissions for a specific user
  getUserPermissions: async (userId, fileType = "net") => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}?user_id=${userId}&file_type=${fileType}`,
        {
          headers: getHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Grant permission to a user
  grantPermission: async (invoiceId, userId, fileType = "net") => {
    try {
      const response = await axiosInstance.post(
        BASE_URL,
        {
          invoice_id: invoiceId,
          user_id: userId,
          file_type: fileType,
        },
        {
          headers: getHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Revoke permission from a user
  revokePermission: async (invoiceId, userId, fileType = "net") => {
    try {
      const response = await axiosInstance.delete(BASE_URL, {
        data: {
          invoice_id: invoiceId,
          user_id: userId,
          file_type: fileType,
        },
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Check if current user has permission for file type
  // Backend now does not require invoice_id; if permissions list is not empty => allowed
  hasPermission: async (fileType = "net") => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}?file_type=${fileType}`,
        {
          headers: getHeaders(),
        }
      );

      const permissions = response.data.permissions || [];
      return { success: true, hasPermission: permissions.length > 0, permissions };
    } catch (error) {
      // If error, user doesn't have permission
      if (error.response?.status === 403) {
        return { success: false, hasPermission: false };
      }
      throw error;
    }
  },

  // Grant permission for user file type
  grantUserFilePermission: async (userId, fileType = "net") => {
    try {
      const response = await axiosInstance.post(
        BASE_URL,
        {
          user_id: userId,
          file_type: fileType,
        },
        {
          headers: getHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Revoke permission for user file type
  revokeUserFilePermission: async (userId, fileType = "net") => {
    try {
      const response = await axiosInstance.delete(BASE_URL, {
        data: {
          user_id: userId,
          file_type: fileType,
        },
        headers: getHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
